import { HStack } from '@nx-kit/layout';
import { css, media, styled } from '@nx-kit/styling';
import Logo from 'components/atoms/Logo/Logo';

export const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100px;
  z-index: ${({ theme }) => theme.global.zIndex.header};
`;

export const Bar = styled(HStack)<{ isSticky: boolean }>`
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  padding: 0 14px;
  z-index: ${({ theme }) => theme.global.zIndex.one};
  transition: background-color 200ms 400ms;
  ${({ isSticky, theme }) =>
    isSticky &&
    css`
      background-color: ${theme.global.color.white};
      transition: none;
      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.12);
    `}

  ${media('md')} {
    padding: 0 60px;
    top: 34px;
  }
`;

export const StyledLogo = styled(Logo)`
  width: 140px;
  height: auto;
`;
